import { css } from 'styled-components';
import { media, rem } from '../../../helpers/mixins';
import {
  PURPLE,
  WHITE,
  PURPLE_LIGHT,
  PURPLE_DARK_HEADER,
  PINK,
  GRAY,
  GRAY_TEXT
} from '../../../constants/colors';

export default {

  inputContainer: css`
    margin: 0px 30px 15px 0px;
  `,

  dateContainer: css`
    display: flex;
    flexWrap: wrap;
  `,

  priceContainer: css`
  ${media.md`
    display: flex;
  `};
    padding-inline: 3%;
  
  `,

  buttonContainer: css`
    margin: 10px 0px 0px;
  `,

  grayLabel: ({
    isTotal, maxWidth, textAlign, isSavingMoney
  }) => css`
    font-size: ${rem(isTotal ? '24px' : '16px')};
    color: #666666;
    margin-bottom: 16px;
    text-align: ${textAlign || 'left'};
  `,

  purplePrice: ({
    isTotal, maxWidth, textAlign, isSavingMoney
  }) => css`
    font-size: 40px;
    color: #3F2A55;
    text-align: ${textAlign || 'left'};
  `,

  purpleUsd: ({
    isTotal, maxWidth, textAlign, isSavingMoney
  }) => css`
    font-size: 30px;
    color: #3F2A55;
    text-align: ${textAlign || 'left'};
    padding-top: 9px;
    padding-left:10px;
    padding-right:10px;
  `,

  addPlacesConatiner: css`
    display: block;
    width: min-content;
  `,

  rounderComponent: css`
    display: flex; 
    justify-content: space-around;
    width: 50%
  `,

  increment: css`
    width: 30px; 
    height: 30px;
    border-radius: 30px; 
    background-color: white; 
    border: 2px;
    border-color: gray;
    justify-content: center; 
    border-width: 1.5px;
    border-style: solid;
    border-color: gray;
    display: flex;
    margin-right: 8px; 
    color: pink; 
    font-weight: bolder;
    cursor: pointer;
  `,

  destinationWrapper: css`
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    width: auto;
    height: auto;

    ${media.md`
      display: flex;
      justify-content: center;
      flex-direction: row;
    `};
  `,

  parkingWrapper: css`
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    width: auto;
    height: auto;
   
    ${media.switchHeaderToDesktop`
      padding: 20px 0px 0px;   
    `};

    ${media.md`
      display: flex;
      justify-content: center;
      flex-direction: row;
      padding: 20px 80px 0px; 
    `};
  `,

  personalInfoWrapper: css`
    flex: 1;
    padding: 16px 16px 16px;

    ${media.sm`
      display: grid;
      grid-template-columns: repeat(2, 1fr);
    `};
  `,
  column: css`
    ${media.md`
      display: flex;
      flex-direction: column;
      margin: auto;
    `};
  `,
  rowOriginDestination: css`
    display: grid;
    grid-template-columns: repeat(3, minmax(10px, 1fr));
    ${media.md`
      display: flex;
      width: 100%;
      flex-direction: row;
      justify-content: space-around;
      margin: auto;
    `};
  `,
  row: css`
    // display: grid;
    grid-template-columns: repeat(2, minmax(10px, 1fr));
    ${media.sm`
      display: flex;
      flex-wrap:wrap;
      width: 100%;
      flex-direction: row;
      justify-content: space-around;
      margin: auto;
    `};
  `,
  placeWrapper: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    align-self: center;
    height: auto;
    width: 95px;
    padding: 20px 8px 20px;
    border-radius: 15%;
    margin-bottom: 5px;
    border-width: 2px;
    border-style: solid;
  `,
  placeCode: css`
    font-size: 25px;
    margin-inline: auto;
  `,
  placeStr: css`
    font-size: 13px;
    margin-inline: auto;
  `,
  placeLabel: ({ color }) => css`
    color: ${color || GRAY_TEXT};
    font-size: ${rem('10px')};
    width: 95%;
    align-self: end;
  `,
  togglePlaces: css`
    width: 30px;
    height: 30px;
    display: flex;
    align-self: center;
    justify-self: center;
    margin-bottom: 20px;
  `,
  inputRounderSelect: ({
    type, width, padding, hasBlackTheme, value, isSorting, textColor
  }) => css`
  border-radius: 10px;
  border-bottom: 1px solid ${GRAY_TEXT};
  font-weight: bolder;
  color: #726C79;
  font-size: 1rem;
  padding-inline: 5px 0;
  width: ${width || '100%'};
  height: 34px;
  margin-left ${padding || 0};
  border: ${isSorting ? 'none' : `1px solid ${hasBlackTheme ? '#ccc' : GRAY_TEXT}`};
  background-color: white;

  ${value === '' && hasBlackTheme && css`
    color: #757575;
  `}

  ${isSorting && css`
    border: none;
  `}

  ${type === 'date' && !textColor && css`
    &::-webkit-calendar-picker-indicator {
      filter: invert(1);
    }
  `}
  option {
    color: black;
    font-size: ${rem('16px')};
  }
`,
  labelInput: ({ color }) => css`
    color: ${color || GRAY_TEXT};
    font-size: ${rem('10px')};
    margin-top: 4px;
    margin-bottom: 5px;
  `,

  inputsWrapper: css`
    display: flex;
    flex-direction: column;
    width: 95%;
    margin-top: 10px;
    justify-self: center;
    ${media.md`
      margin-top: 0;
      margin-inline: 10px;
      width: auto;
      // margin-bottom: 5px
  `}
  `,
  divCalendar: ({ width, hasBlackTheme, isSorting }) => css`
  border-radius: 10px;
  border-bottom: 1px solid ${GRAY_TEXT};
  font-weight: 900;
  color: #292033;
  padding-inline: 10px 0;
  width: ${width || '90px'};
  border: ${isSorting ? 'none' : `1px solid ${hasBlackTheme ? '#ccc' : GRAY_TEXT}`};
`,
  subtitle: css`
    font-size: 15px;
    padding: 10px 0px 10px;
    `,

  info: ({
    isTotal, maxWidth, textAlign, isSavingMoney
  }) => css`
    font-size: ${rem(isTotal ? '24px' : '16px')};
    color: ${PINK};
    margin-bottom: 16px;
    text-align: ${textAlign || 'left'};

    ${isTotal
    && css`
        flex: 1;
        margin-left: 8px;
        justify-self: flex-start;
        margin-bottom: 0;
        line-height: ${rem('32px')};
        margin-right: 24px;

        ${media.sm`
        font-size: ${rem(isSavingMoney ? '13px' : '20px')};
      `} ${media.md`
        font-size: ${rem(isSavingMoney ? '20px' : '24px')};
      `};
      `} ${maxWidth
    && css`
        max-width: 85%;
        margin-top: 8px;

        ${media.sm`
        max-width: ${maxWidth};
      `};
      `}

    span {
      text-decoration: line-through;
      color: ${GRAY};
    }
  `,

  banner: css`
    object-fit: contain;
    width:65%; 
    height:350px;
  `,

  pinkBannerTitle: () => css`
    font-size: 25px;
    color: #E05C96;
  `,

  pinkBannerText: () => css`
    font-size: 18px;
    color: #E05C96;
  `,


};
